import  { Component } from 'react';
import {RadioBox} from './radiobox';
import {FormError} from './form-errors';
class Demandeur extends Component {

    constructor (props){
        super(props);

        this.state = {
            currentForm : 1,
            errorMessage : [],
            showQuestionAdditionel:null,
            demandeur : {
                age : 'undefined' ,
                etudiant: false,
                chomeur_longue_duree: false,
                handicap: false,
                inapte_travail: false,
                enceinte: false,
                nationalite: "FR",
                echelon_bourse :-1,
                ass_precondition_remplie :false,
                aah_restriction_substantielle_durable_acces_emploi :false,
                taux_incapacite :0.3,
                date_naissance : null,
                enfant_a_charge : false,

            }
        };

        this.optionsNationalite = {
            'Française'  : 'FR' ,
            'EEE - UE - Suisse' :'EEE - UE - Suisse' ,
            'Hors UE' :'Hors UE' 
        };

        this.state.situations = {
            "etudiant":{
                "value":false,    
                "label":"Etudiant·e, Apprenti·e"
            },
            "retraite":{
                "value":false,    
                "label":"Retraité-e"
            },
            "chomeur":{
                "value":false,    
                "label":"Inscrit comme demandeur d'emploi"
            },
            "handicap":{
                "value":false,    
                "label":"En situation de handicap"
            },
            "inapte_travail":{
                "value":false,
                "label":"Inapte au travail"
            },
            "enceinte":{
                "value":false,    
                "label":"Vous attendez un enfant"
            },
            "aucune_situations":{
                "value":false,    
                "label":"En activité / dans aucune de ces situations"
            }
        };

    }

    /*  Event handling methods */
    changeSituationCheck = (situation,e)=>{
        this.setState( ({situations,showQuestionAdditionel})=>{

            situations[situation].value =  e.target.checked;
            const newShowQuestion = situations['chomeur'].value 
                || situations['handicap'].value 
                || situations['etudiant'].value ;

            showQuestionAdditionel = (showQuestionAdditionel === null && newShowQuestion === false) ? null : newShowQuestion;

            return {
                situations:situations,
                showQuestionAdditionel:showQuestionAdditionel
            };
        });
    }

    changeEchelonBourse = (e)=>{
        const newVal = parseInt(e.target.value) ;

        this.setState( ({demandeur}) =>{
            demandeur.echelon_bourse = newVal;
            return {demandeur : demandeur};
        });
    }

    captureTauxIncapacite = (e)=> {
        const taux_incapacite = parseInt(e.target.value);
        if (!isNaN(taux_incapacite)){
            this.setState(({demandeur})=>{
                demandeur.taux_incapacite =taux_incapacite/10;
                return {demandeur:demandeur};
            })
        }

    }

    valideDateFinContrat = ()=>{
        const formatDate = /^[0-9]{1,2}\/[0-9]{4}$/i;
        return this.state.demandeur.date_fin_contrat && this.state.demandeur.date_fin_contrat.match(formatDate) != null;
    }

    captureDateFinContrat = (e)=>{
        var newDate = e.target.value;
        const  months = [
          'janvier',
          'février',
          'mars',
          'avril',
          'mai',
          'juin',
          'juillet',
          'aout',
          'septembre',
          'octobre',
          'novembre',
          'décembre'
        ];
        
        this.setState( ({demandeur})=>{
            demandeur.date_fin_contrat= newDate;
            let data = {};
            if (newDate.toString().length > 4) {
              let dateYearContrat = newDate.toString().replace(/\//, '-');

              let eyear = dateYearContrat.split('-')[1] + '-' + dateYearContrat.split('-')[0];

                data.AnneeFinContrat = parseInt(new Date(eyear).getFullYear());
                data.moisFinContrat = months[parseInt(new Date(eyear).getMonth())];

                if (!isNaN(data.AnneeFinContrat)) {
                  data.AnneeMdix = data.AnneeFinContrat - 10;
                }
              
            }
            
            return {...{demandeur : demandeur},...data};
        });
    }

    capturePreconditionAss= (val) =>{
        this.setState(({demandeur})=>{
            let newVal = JSON.parse(val);
            demandeur.ass_precondition_remplie=newVal;
            return {demandeur:demandeur}
        });
    }

    handleChange =(e)=>{
        this.setState ( ({demandeur}) =>{
            demandeur.age = parseInt(e.target.value);
            return {demandeur : demandeur };
        });
    }

    captureNationalite = (newValue) =>{
        this.setState(({demandeur}) =>{
            demandeur.nationalite = newValue;
            if (demandeur.nationalite !== "Française"){
                demandeur.duree_possession_titre_sejour = 25;
            }
            return {demandeur : demandeur};
        })
    }
    
    handleChangeGir = (newValue)=> {
        this.setState( ({demandeur})=> {
            demandeur.gir =  newValue;
            return {demandeur:demandeur};
        }); 
    }
    changeDemandeurACharge = (newValue) =>{
        this.setState( ({demandeur})=> {
            demandeur.enfant_a_charge =  !JSON.parse(newValue);
            return {demandeur:demandeur};
        });
    }
    changeRsaCondition = (newValue)=>{
        this.setState( ({demandeur})=> {
            demandeur.rsa_jeune_condition_heures_travail_remplie =  JSON.parse(newValue);
            return {demandeur:demandeur};
        });
    }

    changeDureeSejourValide = (e) =>{
        const dureeSejourValide = e.target.checked;
        this.setState( ({demandeur})=> {
            if ( dureeSejourValide  === true) {
                demandeur.duree_possession_titre_sejour =   25;
            } else {
                delete demandeur.duree_possession_titre_sejour
            }
            return {demandeur:demandeur};
        });
    }
    switchRadio = (newValue , modelName)=>{
        this.setState(({demandeur})=>{
            demandeur[modelName] = JSON.parse(newValue);
            return {demandeur:demandeur}
        })
    }
    
    synchSituation = async () =>{
        for ( let situation in this.state.situations){
            this.setState( ({demandeur,situations})=>{
                demandeur[situation] = situations[situation].value;            
               
                if ( situation === "etudiant" && demandeur[situation]) {
                    demandeur.activite = 'etudiant';
                } else if (situation === "retraite" && demandeur[situation]) {
                    demandeur.activite = 'retraite';
                } else if (situation === "chomeur" && demandeur[situation]) {
                    demandeur.activite = 'chomeur';
                } else if ( (situation === "inapte_travail" || situation==="aucune_situations") && demandeur[situation]){
                    demandeur.activite = 'inactif';
                }

                return {demandeur:demandeur};
            });
        }
    }
    getBirthDateFromAge = function (age) {
      const today = new Date();
      return new Date(today.getFullYear() - age, today.getMonth(), today.getDate() - 1);
    };

    nextForm = () =>{
        // synch data demandeur with situations .
        this.synchSituation()
        .then(()=>{
            // Send data to <simulateur> component .
            const data = { "demandeur" : this.state.demandeur } ;
            data.demandeur.date_naissance = this.getBirthDateFromAge(data.demandeur.age);

            let date = data.demandeur.date_fin_contrat == undefined ? new Date() : new Date(data.demandeur.date_fin_contrat.replace('/','/01/'));

            data.demandeur.date_fin_contrat = new Date(date - (3600*1000*24));

            this.props.validateStep(data)
        });
    }

    noSpecificSituation = ()=>{
        const noSpecificSituation =  Object.keys(this.state.situations).every( (  situation) =>{
            return this.state.situations[situation].value == false;
        });

        return noSpecificSituation ;
    }

    nextStep = () => {
        let validationPassed = true;

        if ( this.state.currentForm === 1 && (['undefined', NaN , undefined , null].includes(this.state.demandeur.age)|| this.state.demandeur.age <= 0) ) {
            validationPassed = false;
            this.setState({errorMessage : ['Veuillez saisir un age valide.'] });
        }
        
        if (this.state.currentForm === 3  && this.noSpecificSituation()) {
            validationPassed = false;
            this.setState({errorMessage : ["Veuillez renseigner votre situation."] } );
        }

        if (validationPassed){

            this.setState({
                currentForm  : this.state.currentForm+1,
                errorMessage : [],
            });

            if ( this.state.currentForm >= 3 ) {
                this.nextForm();
                document.getElementById('anchor').scrollIntoView({behavior:'smooth'}) ;
            }
        }
    }

    restart = () => {
        this.setState({currentForm : 1}); 
        this.props.restart();
    }


    girQuestion = () =>{
        return   <div className="question question-aide-personne" >
                    <RadioBox 
                      options={{
                        "Jamais":"gir_6",
                        "Ponctuellement": "gir_5",
                        "Régulièrement": "gir_1"

                      }}
                      name ="gir"
                      defaultValue={this.state.demandeur.gir}
                      handler={this.handleChangeGir}
                    ><h3>Avez-vous besoin d'une aide à la personne&nbsp;?</h3></RadioBox>                        
                </div>;
    }

    questionDemandeurACharge = () =>{
        return  <div className="question-demandeur">
                    <RadioBox
                        name="demandeur-a-charge"
                        defaultValue={!this.state.demandeur.enfant_a_charge}
                        options={{"Oui":true, "Non":false}}
                        handler={this.changeDemandeurACharge}
                    >
                        <h4>Remplirez-vous &agrave; votre nom la prochaine d&eacute;claration d'imp&ocirc;ts&nbsp;?</h4>
                    </RadioBox>
                    
                </div>;
    }
    
    questionConditionRsa = ()=>{
        return <div className="question-demandeur">
                <RadioBox 
                    options={{"Oui":true,"Non":false}}
                    handler={this.changeRsaCondition}
                    defaultValue={this.state.demandeur.rsa_jeune_condition_heures_travail_remplie}
                    name="rsa_jeune_condition_heures_travail_remplie"
                >
                    <h4>Avez-vous eu une activité professionnelle à temps plein pendant au moins 2 ans au cours des 3 dernières années ?</h4>
                </RadioBox>
                    
                        
                </div>;
    }
    /*  Views methods  */
    demandeurAge = ()=>{
        return <div className="step-inner-container step-demandeur">
                <p className="step-title"><strong>Mon profil</strong></p>
                <div className="age">
                    <label htmlFor="age">Age</label>
                    <p> J'ai <input 
                        type="number"
                        name="age"
                        onChange={this.handleChange}
                        value = {this.state.demandeur.age}
                        placeholder="ex:30"
                    /> ans. </p>
                </div>
                { (this.state.demandeur.age >= 60) ? 
                   this.girQuestion() : ''
                }
                { (this.state.demandeur.age>=18 && this.state.demandeur.age <= 24)?(
                    <>
                        { this.questionDemandeurACharge() }
                        { this.questionConditionRsa() }
                    </>
                    ) : ''}
                <FormError errors={this.state.errorMessage} />
                <input type="button" value="Valider" onClick={this.nextStep} />
            </div>;
    }
    
    demandeurNationalite = ()=>{
        return <div className="step-inner-container">
                <p className="step-title"><strong>Mon profil</strong> </p>
        <div className="nationalite">
        <h3>Nationalité</h3>

        <div className="question" >
            <RadioBox 
                name="zone"
                options = {this.optionsNationalite}
                handler= {this.captureNationalite}
                defaultValue= {this.state.demandeur.nationalite}
            >
            </RadioBox>

        </div>
         { (this.state.demandeur.nationalite !== "FR" )?(
                 <div className="question"  >
                    <input  id="dSejour" checked={true} onChange={this.changeDureeSejourValide} type="checkbox"/>
                    <label className="custom-control-label" htmlFor="dSejour" >
                        Résidant en France plus de 9 mois par an
                    </label>
                 </div>
             ): ''}

        </div>
        <input type="button" value="Valider" onClick={this.nextStep}/>
        <input type="button" value="Recommencer" className="restart" onClick={this.restart}/>
        </div>;
    }
    //
   

    demandeurSituation = () => {
        var pourcentageHandicap;
        if (this.state.demandeur.taux_incapacite <0.5){
            pourcentageHandicap = "Moins de 50 %";
        } else if ( this.state.demandeur.taux_incapacite >= 0.5 && this.state.demandeur.taux_incapacite< 0.8) {
            pourcentageHandicap = "Entre 50% et 80%";
        }else if (this.state.demandeur.taux_incapacite >=0.8){
            pourcentageHandicap = "Plus de 80%";
        }

        const listSituation = [] ;
        for ( let situation in this.state.situations){
            listSituation.push({...this.state.situations[situation] , ...{name:situation}});
        }

        return  <div className="step-inner-container step-demandeur">
            <div className="situations-container">
                <p className="step-title"><strong>Mon profil</strong></p>
                <div className={"situation " + (this.state.showQuestionAdditionel? 'questions-situations-left' : '') 
                    +( this.state.showQuestionAdditionel=== false  ?  ' align-right' :'') }>
                    <h3>Situation</h3>
                    <div className="question">
                        <div className="situation-label">
                            <p>Vous êtes :</p>
                            <span className="indication-text">(plusieurs choix possibles)</span>
                        </div>

                        {listSituation.map(  (situation)=>{
                                return <div className="custom-checkbox" key={situation.name}>
                                    <label className="custom-control" htmlFor={situation.name} >
                                        <div className="checkbox-container" >
                                             <input type="checkbox"  
                                                 value={situation.name}
                                                 checked = {this.state.situations[situation.name].value}
                                                 onChange={(e)=>{this.changeSituationCheck(situation.name,e)}}
                                                 className="custom-control-input"
                                                 id={situation.name}/>
                                             <span className="checkmark"></span>
                                        </div>
                                   <span className="label" htmlFor={situation.name} >{situation.label}</span>
                            </label></div>;})}
                        <div className="clear"></div>
                    </div>
                </div>
                <div className={ 'questions-situations-right ' + (this.state.showQuestionAdditionel ? 'slide-in' : 'fade-out')}>
                    {(this.state.situations.etudiant.value === true)?
                        <div className = "fade-in">
                           <h3><label htmlFor="echelon_bourse">À quel échelon êtes-vous boursier ?</label></h3>
                           <input type="range"
                                id="echelon_bourse"
                                name="echelon_bourse"
                                min="-1"
                                max="10"
                                value = {this.state.demandeur.echelon_bourse}
                                onChange={this.changeEchelonBourse}
                            /><br/>
                            {(this.state.demandeur.echelon_bourse >=0) ?
                                <small>Boursier échelon {this.state.demandeur.echelon_bourse}</small>:
                                <small>Non Boursier</small>
                            }

                        </div>
                        :''
                    }
                    { (this.state.situations.chomeur.value === true) ?
                        <div className ={'hidden-question '+ this.state.situations.chomeur.value ? 'fade-in' : 'fade-out'}>
                            <h3>Quand s'est terminé votre dernier contrat de travail ?</h3> 
                            <small>(Si vous n'avez jamais eu de contrat de travail, laissez ce champ vide)</small><br/>
                            <input type="text" placeholder="MM/AAAA" onChange={this.captureDateFinContrat} />
                        </div>
                        :''
                    }
                    { (this.state.situations.chomeur.value === true && this.valideDateFinContrat() && !isNaN(this.state.AnneeFinContrat)  ) ?
                            <div className="fade-in">
                                
                                <RadioBox name="ass_precondition_remplie"
                                    options={{"Oui":true, "Non":false}}
                                    defaultValue={this.state.demandeur.ass_precondition_remplie}
                                    modelName="ass_precondition_remplie"
                                    handler={this.capturePreconditionAss}
                                >
                                    <h3>Avez-vous travaillé au moins 5 ans entre {this.state.moisFinContrat} {this.state.AnneeMdix} et {this.state.moisFinContrat} {this.state.AnneeFinContrat}&nbsp;?</h3>
                                </RadioBox>
                            </div>: ''

                    }
                    { (this.state.situations.handicap.value === true) ?
                        <>
                            <div className ="fade-in">
                               <h3>Votre taux d'incapacité</h3>
                               <small>(Evalué par votre MDPH)</small>
                               <input type="range"
                                    id="taux_incapacite"
                                    name="taux_incapacite"
                                    min="0"
                                    max="10"
                                    defaultValue={this.state.demandeur.taux_incapacite*10}
                                    onChange={this.captureTauxIncapacite}
                                    />
                                <small>{pourcentageHandicap}</small>
                            </div>

                            <div className = { 
                                (0.5 <= this.state.demandeur.taux_incapacite && this.state.demandeur.taux_incapacite < 0.8 )?
                                "fade-in" : "fade-out"
                            }>
                                
                                <RadioBox name="cdaph"
                                    options={{"Oui":true , "Non":false}}
                                    defaultValue= {this.state.demandeur.aah_restriction_substantielle_durable_acces_emploi}
                                    modelName="aah_restriction_substantielle_durable_acces_emploi"
                                    handler={this.switchRadio}
                                >
                                    <h3>Avez-vous une restriction substantielle et durable d'accès à l'emploi reconnue par la CDAPH ?</h3>
                                    <small>(Attention, cette restriction est différente de la reconnaissance de la qualité de travailleur handicapé.)</small>
                                </RadioBox>
                            </div>
                        </>
                        :''
                    }

                </div>
            </div>
            <FormError errors={this.state.errorMessage} />
            <input type="button" value="Valider" onClick={this.nextStep}/>
            <input type="button" value="Recommencer" className="restart" onClick={this.restart}/>
        </div>;

    }

    render () {
         
        if ( this.state.currentForm === 1 ) {
            return this.demandeurAge();
        } else if (this.state.currentForm === 2) {
            return this.demandeurNationalite();
        } else if (this.state.currentForm >= 3) {
            return this.demandeurSituation();
        }
    }
}

export default Demandeur;
